// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"a630f8fe","331":"86c152c6","453":"5565870f","583":"eee83b06","726":"f458fb75","789":"731cffe5","930":"e673b606"}[chunkId] + ".chunk.js";
};